import "@/App.css";
import { LangProvider } from "@/context/LangContext";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Problem from "@/components/site/Problem";
import HowItWorks from "@/components/site/HowItWorks";
import Benefits from "@/components/site/Benefits";
import Products from "@/components/site/Products";
import FAQ from "@/components/site/FAQ";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";
import Marquee from "@/components/site/Marquee";

function App() {
  return (
    <LangProvider>
      <div className="grain min-h-screen bg-po-bg text-po-text antialiased relative">
        <Nav />
        <main className="relative">
          <Hero />
          <Marquee />
          <Problem />
          <HowItWorks />
          <Benefits />
          <Products />
          <FAQ />
          <FinalCTA />
        </main>
        <Footer />
      </div>
    </LangProvider>
  );
}

export default App;
